import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Relative, Absolute } from 'rebass';
import { Text } from '../index';
import { COLOR, FONT_SIZE } from '../../Theme';
import { getFormattedNumber } from '../Number';

const Container = styled(({ width, ...restProps }) => <Relative my={24} {...restProps} />)`
  width: ${props => props.width};
  height: 10px;
`;

const ProgressWrapper = styled(props => <Container my={0} {...props} />)`
  border-radius: 5px;
  overflow: hidden;
`;

const Progress = styled(({ width, ...restProps }) => <Absolute {...restProps} />)`
  height: 100%;
  width: ${props => props.width};
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
`;

const Marker = ({ percent, label }) => {
  const isRight = percent > 85;
  const pos = isRight
    ? { right: `${100 - percent}%`, textAlign: 'right' }
    : { left: `${percent}%` };

  return (
    <Absolute // left={left}
      style={pos}
      bottom={0}
      zIndex={'1'}
      ml="-1px"
    >
      <Text>{label}</Text>
      <svg width="3" height="16" style={{ display: 'block', marginLeft: isRight ? 'auto' : 0 }}>
        <line
          x1="0"
          y1="0"
          x2="0"
          y2="16"
          stroke={COLOR.darkBlue}
          strokeDasharray="4 2"
          strokeWidth="5"
        />
      </svg>
    </Absolute>
  );
};

const ProgressBar = ({
  marker,
  color,
  backgroundColor,
  maxValue,
  minValue,
  value,
  width,
  showLabel,
}) => {
  const valuePercent = `${(value / (maxValue - minValue)) * 100}%`;
  const BOTTOM_OFFSET = -22;
  return (
    <Container width={width}>
      {marker && <Marker percent={marker.percent} label={marker.label} />}
      <ProgressWrapper bg={backgroundColor}>
        <Progress width={valuePercent} bg={color} />
      </ProgressWrapper>
      {showLabel && (
        <Fragment>
          <Absolute left={0} bottom={BOTTOM_OFFSET} zIndex={'1'}>
            <Text>{minValue}</Text>
          </Absolute>
          <Absolute right={0} bottom={BOTTOM_OFFSET} zIndex={'1'}>
            <Text>{getFormattedNumber(maxValue)}</Text>
          </Absolute>
          <Absolute left={valuePercent} bottom={BOTTOM_OFFSET} zIndex={'1'}>
            <Text ml="-50%">{getFormattedNumber(value)}</Text>
          </Absolute>
        </Fragment>
      )}
    </Container>
  );
};

ProgressBar.propTypes = {
  marker: PropTypes.shape({
    label: PropTypes.string,
    percent: PropTypes.number,
  }),
  color: PropTypes.string,
  backgroundColor: PropTypes.string,
  maxValue: PropTypes.number,
  minValue: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.string,
  showLabel: PropTypes.bool,
};

ProgressBar.defaultProps = {
  marker: {},
  minValue: 0,
  color: 'secondary',
  backgroundColor: 'darkBlue',
};

export default ProgressBar;
